var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRectangle44({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1440 187",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1440 187L0 187L2.9269e-05 5.97935e-06L1440 7.62939e-05L1440 187Z",
    fill: "url(#paint0_linear_1364_177)",
    fillOpacity: 0.7
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1364_177",
    x1: 720,
    y1: 187,
    x2: 720,
    y2: 82.5697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000039",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#000039"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangle44);
export default __webpack_public_path__ + "static/media/Rectangle 44.de418a08ef48d3f16e447044247f01b1.svg";
export { ForwardRef as ReactComponent };